import api from "./Api";

// Builds the query params for the support list endpoint, omitting any that
// are empty so the request stays clean (e.g. no "?lsp_name=&start_date=").
const buildIssuesParams = ({
  outlet_name,
  order_id,
  delivery_partner,
  lsp_name,
  start_date,
  end_date,
  page_size,
} = {}) => {
  const params = {};
  if (outlet_name) params.outlet_name = outlet_name;
  if (order_id) params.order_id = order_id;
  if (delivery_partner) params.delivery_partner = delivery_partner;
  if (lsp_name) params.lsp_name = lsp_name;
  if (start_date) params.start_date = start_date;
  if (end_date) params.end_date = end_date;
  if (page_size) params.page_size = page_size;
  return params;
};

export const getDeliveryIssues = (cursorUrl = null, filters = {}) => {
  if (cursorUrl) {
    // Absolute URLs (from backend cursor responses) are passed directly so
    // axios skips baseURL and avoids double-prefixing (e.g. /api/api/...).
    // Relative cursor URLs are passed as-is and have baseURL applied normally.
    return api.get(api.normalizeUrl(cursorUrl)).then((r) => r.data);
  }
  return api
    .get("/operations/delivery-issues/support/", {
      params: buildIssuesParams(filters),
    })
    .then((r) => r.data);
};

export const approveIssue = (id) =>
  api.patch(`/operations/delivery-issues/${id}/approve/`).then((r) => r.data);

export const rejectIssue = (id, payload) =>
  api
    .patch(`/operations/delivery-issues/${id}/reject/`, payload)
    .then((r) => r.data);

export const bulkProcessIssues = (issue_ids) =>
  api
    .post("/operations/delivery-issues/bulk-process/", { issue_ids })
    .then((r) => r.data);

export const createDeliveryIssue = (payload) =>
  api.post("/operations/delivery-issues/create/", payload).then((r) => r.data);
